import type { ReactNode } from "react";

/**
 * A plain layout container for a list screen's filters/chips/result-count/
 * action row (design.md §5.2). Deliberately `role="group"`, never
 * `role="search"` — this codebase's list screens have no free-text search
 * backed by an API parameter today (see `features/campaigns/filters.ts`'s
 * disclosed `q` omission); labeling this a "search" landmark would be
 * misleading to assistive-technology users looking for a search field that
 * does not exist. `Toolbar` owns only the wrapper; the feature owns every
 * filter/action inside it (design.md §7).
 */
export function Toolbar({ ariaLabel, children }: { ariaLabel: string; children: ReactNode }) {
  return (
    <div role="group" aria-label={ariaLabel} className="v2-toolbar">
      {children}
    </div>
  );
}
